import { DealStatusBadge } from '@/components/deal/status/deal-status-badge';
import { getStatusOptions } from '@/components/deal/status/deal-status-selector';
import { DEAL_STATUS_LABEL } from '@/lib/constants';
import type { Status } from '@/models/types';
import StatusFiltersComboBoxPopover from '../combobox-popovers/status-filters-combobox-popover';
import type { StatusFilterChipProps, StatusFiltersState } from '../types';
import BaseFilterChip from './base-filter-chip';

const STATUS_OPTIONS_MAP = getStatusOptions({
  className: 'h-3 w-3',
});

const StatusFilterChip = (props: StatusFilterChipProps) => {
  const {
    filtersState,
    setFiltersState,
    deleteFilter,
    shouldDeleteWhenNoFiltersAreSelected,
  } = props;

  return (
    <BaseFilterChip<Status, StatusFiltersState>
      filtersState={filtersState}
      setFiltersState={setFiltersState}
      FiltersComboBoxPopover={StatusFiltersComboBoxPopover}
      deleteFilter={deleteFilter}
      representativeIcon={<DealStatusBadge value="new" hideCopy />}
      filterName={`${DEAL_STATUS_LABEL}...`}
      filterQuantifier={{ singular: 'status', plural: 'statuses' }}
      SelectedFilterBadge={DealStatusBadge}
      shouldDeleteWhenNoFiltersAreSelected={
        shouldDeleteWhenNoFiltersAreSelected
      }
      getLabelForValue={(value) =>
        STATUS_OPTIONS_MAP.find((option) => option.value === value)?.label as
          | string
          | undefined
      }
    />
  );
};

export default StatusFilterChip;
